import React from 'react';
import ReactSpeedometer from "react-d3-speedometer";


const Meter = ({val}) => {
    return(
      <>
      <center><h2>Overall Score Of Reviews</h2></center>
        <hr className="line"/>
       <center>
            <ReactSpeedometer 
                value={val}
                segments={10}
                minValue={-100}
                maxValue={100}
                startColor="#EB2C47"
                endColor="#03C785"
                customSegmentLabels={[
                        {
                          text: "Bad",
                          position: "INSIDE",
                          color: "#fff"
                        },
                        {
                          text: "",
                          position: "INSIDE",
                          color: "#fff"
                          
                        },
                        {
                          text: "",
                          position: "INSIDE",
                          color: "#fff"
                        },
                        {
                            text: "",
                            position: "INSIDE",
                            color: "#fff"
                          },
                          {
                            text: "Neutral",
                            position: "INSIDE",
                            color: "#fff"
                            
                          },
                          {
                            text: "",
                            position: "INSIDE",
                            color: "#fff"
                          },
                          {
                            text: "",
                            position: "INSIDE",
                            color: "#fff"
                          },
                          {
                            text: "",
                            position: "INSIDE",
                            color: "#fff"
                            
                          },
                          {
                            text: "",
                            position: "INSIDE",
                            color: "#fff"
                          },
                          {
                            text: "Good",
                            position: "INSIDE",
                            color: "#fff"
                          }

                      ]}
            />
       </center>
       </>
    )
};

export default Meter;

// segmentColors={[
//     "#EB2C47",
//     "#E7BD16",
//     "#03C785",
    
//   ]}

//   customSegmentLabels={[
//     {
//       text: "Bad",
//       position: "INSIDE",
//       color: "#fff"
//     },
//     {
//       text: "Neutral",
//       position: "INSIDE",
//       color: "#fff"
      
//     },
//     {
//       text: "Good",
//       position: "INSIDE",
//       color: "#fff"
//     }
//   ]}